import React from "react";
import styled from "styled-components";
import { colors } from "../common/mixins.js";
import animationData from "./mastercard-gif.json";
import LottieAnimation from "../common/LottieAnimation.jsx";

const Container = styled("div")({
  position: "relative",
  width: "100%",
  padding: "16px",
  borderRadius: "8px",
  backgroundColor: "#FFFFFF",
  border: `1px solid ${colors.primary}`,
  "> * ": {
    color: "#0D0C1C",
    fontFamily: `"pf_highway_sans_pro_lightRg", sans-serif`,
    fontSize: "16px",
    fontWeight: "400",
  },
  "> p": {
    marginBottom: 16,
  },
});

const Title = styled("div")({
  fontWeight: 600,
  fontSize: 20,
  marginBottom: 16,
});

const StyledLink = styled("a")({
  color: "#502CB5",
});

const BottomFlex = styled("div")({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
});

const Code = styled("div")({
  background: "#F3F6F9",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  borderRadius: 8,
  padding: "12px 16px",
  gap: 4,
  textAlign: "center",
});

const Mastercard = ({ mastercardCoupon, mastercardCampaignEndDate , mastercardLandingPageUrl, culture}) => {
    const date = new Date(mastercardCampaignEndDate);
    const formattedDate = new Intl.DateTimeFormat(culture, {
        day: 'numeric',
        month: 'numeric',
        year: 'numeric'
    }).format(date);
  return (
    <Container>
      <LottieAnimation animationData={animationData} />
          <Title>{orderdetails_resources.Congratulations}</Title>
          <p>{orderdetails_resources.MastercardDescription} </p>   
      <p>
              {orderdetails_resources.MastercardUseYourCode} <b>{formattedDate}</b>.
              {' '} {orderdetails_resources.MastercardCheckPerformances}{' '}
              
              <StyledLink href={mastercardLandingPageUrl} target="_blank">
                  {orderdetails_resources.Here}
              </StyledLink>.
          </p>
          <p> {orderdetails_resources.MastercardFindYourCode}</p>
      <BottomFlex>
        <Code>
         <span>{orderdetails_resources.UniqueCode}</span>
          <span>
          <b>{mastercardCoupon}</b>
          </span>
        </Code>
        <div>
          <img src="/Site/images/icons/order-details/mastercard.png"></img>
        </div>
      </BottomFlex>
    </Container>
  );
};

export default Mastercard;
